import React from 'react';

export const SignIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21.095" height="20.323" viewBox="0 0 21.095 20.323">
      <g transform="translate(-88.346 -1418.051)">
        <path  d="M1337.027,1437.687a1.579,1.579,0,0,0-.789-1.246c-.729-.345-.87.572-1.486.276s-.159-1.3-.758-1.3-1.188,1.343-1.638,1.028-.5-3.037-1.334-2.666-.992,1.389-2.02,1.484-2-5.316,1.614-5.134" transform="translate(-635.628 -383.657) rotate(21)" fill="none" stroke="#374151" strokeLinecap="round" strokeWidth="1"/>
        <g transform="translate(29.952 -0.624)">
          <path d="M1340.493,1423.5l1.542-3.936.044-.115" transform="translate(-1263.43 3.602)" fill="none" stroke="#374151" strokeLinecap="round" strokeWidth="1.3"/>
          <path d="M1342.047,1425.313l3.063,1.172,1.953-5.359a3.36,3.36,0,0,0-1.344-1.109,3.219,3.219,0,0,0-1.719,0Z" transform="translate(-1270)" fill="#374151" stroke="#374151" strokeLinecap="round" strokeWidth="0.1"/>
          <path d="M1340.493,1420.065l.249-.6.007-.017" transform="translate(-1264.765 -0.123)" fill="none" stroke="#374151" strokeLinecap="round" strokeWidth="1"/>
          <path d="M1341.52,1426.589l-2.661,7.292,3.087,1.2,2.742-7.333Z" transform="translate(-1270)" fill="#374151" stroke="#374151" strokeLinecap="round" strokeWidth="0.1"/>
          <path d="M1338.859,1433.921a9.169,9.169,0,0,0-.3,2.316,4.167,4.167,0,0,0,.487,1.767,3.412,3.412,0,0,0,1.584-.874,7.294,7.294,0,0,0,1.28-1.99Z" transform="translate(-1270)" fill="#374151" stroke="#374151" strokeWidth="0.1"/>
          <path d="M1340.493,1420.065l.249-.6.007-.017" transform="translate(-1271.634 18.246)" fill="none" stroke="#374151" strokeLinecap="round" strokeWidth="0.4"/>
        </g>
      </g>
    </svg>

  );
};

export default SignIcon;
